import positionBlueSvg from '../../../assets/svg/Icons/32/position-blue.svg';
import { colors } from '../../../constants';
import ManageGroupCtrl from '../groups/ManageGroupCtrl';

import managePositionUrl from './managePosition.html';

class ManagePositionCtrl extends ManageGroupCtrl {
  constructor(
    Authentication,
    ConfirmService,
    Utils,
    Groups,
    PersonaCollection,
    Restangular,
    AlertService,
    UserUtils,
    PremiumDiscoveryService,
    IntegrationService,
    $timeout,
    $state,
    $location,
    $sce,
    $uibModal,
    focus,
    uppercaseFirstFilter,
    displayNumberFilter
  ) {
    'ngInject';

    super(
      ConfirmService,
      Utils,
      Groups,
      PersonaCollection,
      Restangular,
      AlertService,
      UserUtils,
      $timeout,
      $state,
      $location,
      $sce,
      $uibModal,
      focus,
      uppercaseFirstFilter
    );
    Object.assign(this, {
      Authentication,
      Restangular,
      PremiumDiscoveryService,
      displayNumberFilter,
      IntegrationService,
    });
  }

  $onInit() {
    this.numberWithDecimalPattern = this.Utils.getNumberValidationPattern();
    this.icon = positionBlueSvg;
    this.colors = colors;

    this.wagesForms = {};
    this.addDummyWageIfNeeded();

    if (this.group.id && this.Authentication.user.wouldHaveAccessToLaborCost) {
      this.tabs.push({ value: 'wages', label: 'wages' });
    }
    super.$onInit();
    this.setupNameHandling();
  }

  async setupNameHandling() {
    this.canEditName = true;

    if (!this.position.origin) {
      return;
    }

    const integrations = await this.IntegrationService.getAvailableIntegrations();
    this.canEditName = !integrations
      .find((integration) => integration.type === this.position.origin)
      .userSharedFields.includes('positions');

    if (!this.canEditName) {
      this.nameTooltipText = `Edit this field on ${this.position.origin} side first for Sling to reflect any required updates.`;
    }
  }

  get position() {
    return this.group;
  }

  set position(val) {
    this.group = val;
  }

  addDummyWageIfNeeded() {
    if (!this.position.wages) {
      this.position.wages = [];
    }

    if (
      this.Authentication.user.wouldHaveAccessToLaborCost &&
      this.position.wages.filter((w) => !w.deleted).length === 0
    ) {
      this.addWageRate();
    }
  }

  addWageRate() {
    this.position.wages.push({
      fromDate: new Date(),
      positionId: this.position.id,
      regularRate: null,
    });
    this.form?.$setDirty();
  }

  deleteWageRate(wage) {
    const index = this.position.wages.indexOf(wage);

    if (index >= 0) {
      this.position.wages[index].deleted = true;
    }

    this.addDummyWageIfNeeded();
    this.form.$setDirty();
  }

  async submit() {
    this.error = false;
    if (this.form.$invalid) {
      this.form.$setSubmitted();
      return;
    }

    const wagesToBulkUpdate = [];
    if (this.Authentication.user.hasAccessToLaborCost && this.position.wages) {
      this.position.wages.forEach((wage) => {
        if (!wage.regularRate) {
          wage.deleted = true;
          wage.regularRate = 0;
        }

        if (wage.deleted && 'id' in wage) {
          wagesToBulkUpdate.push(wage);
        } else if (!wage.deleted && !('id' in wage) && wage.regularRate) {
          wagesToBulkUpdate.push(wage);
        } else if (!wage.deleted && this.wagesForms[wage.$$hashKey]?.$dirty && wage.regularRate) {
          wagesToBulkUpdate.push(wage);
        }
      });
    }

    this.addDummyWageIfNeeded();

    let result;
    if (!this.position.id) {
      result = await this.baseSubmit();
      wagesToBulkUpdate.forEach((wage) => (wage.positionId = result.id));
    }

    if (wagesToBulkUpdate.length) {
      await this.Restangular.all('labor/wages/position/bulk').customPUT(wagesToBulkUpdate);
      this.PremiumDiscoveryService.featureDiscovered(
        this.PremiumDiscoveryService.FEATURE_NAMES.LABOR_COST
      );
    }

    return result || (await this.baseSubmit());
  }

  /*
    for some strange reason calling super.submit()
    inside an async method (and not only) is buggy in V8
    http://stackoverflow.com/questions/32932699/calling-super-method-inside-promise-super-keyword-unexpected-here
  */
  baseSubmit() {
    return super.submit();
  }

  cancel() {
    super.cancel();
    this.addDummyWageIfNeeded();
  }
}

export default {
  controller: ManagePositionCtrl,
  controllerAs: 'ctrl',
  templateUrl: managePositionUrl,
  bindings: {
    group: '<',
    previousState: '<',
    tab: '@',
  },
};
